import { useParams } from 'react-router-dom';
import ExtendOrder from './extendOrder';
import { Box } from '@mui/material';

export const ShowOrder = () => {
  const { id } = useParams();
  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendOrder row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
